require('backbone.stickit');
var ValidationBehavioursMixin = require('./validation-behaviours-mixin');
var Textbox = Marionette.ItemView.extend({
template: function () {
    return '';
},
className: function () {
    var classNames = ['tl-textbox', 'form-control'];
    if (this.options.classNames) {
        classNames = classNames.concat(this.options.classNames);
    }
    return classNames.join(' ');
},
tagName: function () {
    if (this.options.multiLine) {
        return 'textarea';
    }
    return 'input';
},
attributes: function () {
    return {
        type: this.options.password ? 'password' : 'text',
        placeholder: this.options.placeholder
    };
},
events: function () {
    return {
        'input': _.debounce(this.clearErrorState, 10),
        'focus': _.debounce(this.clearErrorState, 10),
        'keypress': '_checkKeyPressForEnter'
    };
},
bindings: function () {
    if (!this.options.modelAttr) {
        return null;
    }
    return {
        ':el': {
            observe: this.options.modelAttr
        }
    };
},
val: function (val) {
    if (_.isUndefined(val)) {
        return this.$el.val();
    }
    this.$el.val(val);
},
_checkKeyPressForEnter: function (e) {
    if (e.which === 13) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (this.options.enterPressedCallback) {
            this.options.enterPressedCallback();
        }
        this.trigger('enter:pressed');
    }
},
initialize: function (options) {
    var that = this;
    this.options = _.defaults(
        options || {},
        {
            enabled: true,
            placeholder: '',
            classNames: '',
            modelAttr: null,
            useValidationBehaviours: false,
            multiLine: false,
            password: false,
            focused: false
        }
    );

    this.state = new Backbone.Model({
        enabled: this.options.enabled,
        placeholder: this.options.placeholder,
        popoverActivated: false,
        invalid: false
    });

    if (this.options.useValidationBehaviours && this.options.modelAttr) {
        this.listenTo(this.model, 'validated', function(isValid, model, errors) {
            if (isValid) {
                that.clearErrorState();
            } else {
                if (_.has(errors, that.options.modelAttr)) {
                    that.setErrorState(errors[that.options.modelAttr]);
                }
            }
        });
    }


},
isEnabled: function () {
    return this.state.get('enabled');
},
setPlaceholder: function (val) {
    this.state.set('placeholder', val);
    this.$el.attr('placeholder', val);
},
toggledEnabledState: function (enabled) {
    if (enabled) {
        this.state.set('enabled', true);
        this.$el.removeClass('disabled');
    } else {
        this.state.set('enabled', false);
        this.$el.addClass('disabled');
    }
},
focus: function () {
    var that = this;
    setTimeout(function () {
        that.$el.trigger('focus');
    }, 0);
},
onDestroy: function () {
    if (this.options.useValidationBehaviours) {
        this.hidePopover();
    }
    if (this.bindings()) {
        this.unstickit();
    }
},
onRender: function () {
    if (this.bindings()) {
        this.stickit();
    }
    if (this.options.focused) {
        this.focus();
    }
    if (this.options.modelAttr) {
        this.$el.attr('name', this.options.modelAttr);
    }
},
serializeData: function () {
    return {
        state: this.state.toJSON()
    };
}
});

_.extend(Textbox.prototype, ValidationBehavioursMixin);

module.exports = Textbox;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/textbox.js
 ** module id = 73
 ** module chunks = 1 2 3 4 8 9 15 18 19 20 21 24 40 53 64 66 78 81 89 93
 **/